export const addNamespace = (action: string): string =>
	'lib_asset_schema' + '/' + action;
